import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';
import PageMeta from '@/components/SEO/PageMeta';

const CGV = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="CGV La Patrimoniale - Conditions Générales de Vente Gestion de Patrimoine"
        description="Consultez les conditions générales de vente de La Patrimoniale, cabinet de gestion de patrimoine basé à Paris : modalités de nos services, tarification, description des prestations, obligations contractuelles, règlement des litiges. La Patrimoniale garantit la transparence, l'éthique professionnelle et l'accompagnement sur-mesure pour chaque client."
        keywords="La Patrimoniale, CGV gestion patrimoine, conditions générales La Patrimoniale, contrat cabinet patrimoine, tarification gestion patrimoine, accompagnement patrimonial, expert La Patrimoniale, règlement litiges patrimoine, services patrimoniaux Paris"
        canonical="https://www.la-patrimoniale-gestion.com/cgv"
      />
      <Navbar />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-patrimoine-dark mb-8">Conditions Générales de Vente</h1>
          
          <Separator className="mb-8" />
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Préambule</h2>
              <p className="text-gray-700 leading-relaxed">
                LA PATRIMONIALE, société civile au capital de 10 099 700,00 €, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 319 617 809, dont le siège social est situé au 47 BOULEVARD DE BEAUSEJOUR, 75016 PARIS, propose des services de conseil et de gestion en matière de placement de valeurs mobilières, parts d'intérêts et droits mobiliers et immobiliers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Article 1 - Objet et champ d'application</h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes conditions générales de vente (CGV) constituent le socle unique de la relation commerciale entre les parties. Elles ont pour objet de définir les conditions dans lesquelles LA PATRIMONIALE fournit ses services à ses clients.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                Elles s'appliquent sans restriction ni réserve à tous les services proposés par LA PATRIMONIALE.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Article 2 - Description des services</h2>
              <p className="text-gray-700 leading-relaxed">
                LA PATRIMONIALE propose des services de conseil en investissement, de gestion de portefeuille, d'acquisition et de gestion en commun de valeurs mobilières, parts d'intérêts, droits mobiliers et immobiliers.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                Les services précis fournis au client sont détaillés dans la proposition commerciale ou le contrat établi entre LA PATRIMONIALE et le client.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Article 3 - Tarifs et modalités de paiement</h2>
              <p className="text-gray-700 leading-relaxed">
                Les tarifs des services proposés sont ceux en vigueur au jour de la conclusion du contrat. Ils sont exprimés en euros et sont soumis à la TVA au taux en vigueur.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                LA PATRIMONIALE se réserve le droit de modifier ses tarifs à tout moment. Toutefois, elle s'engage à facturer les services commandés aux prix indiqués lors de l'enregistrement de la commande.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                Le règlement des factures se fait selon les modalités prévues dans le contrat conclu entre LA PATRIMONIALE et le client.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Article 4 - Obligations des parties</h2>
              <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-2">4.1 Obligations de LA PATRIMONIALE</h3>
              <p className="text-gray-700 leading-relaxed">
                LA PATRIMONIALE s'engage à fournir les services avec diligence et conformément aux règles de l'art et à la réglementation applicable.
              </p>
              <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-2 mt-4">4.2 Obligations du client</h3>
              <p className="text-gray-700 leading-relaxed">
                Le client s'engage à fournir à LA PATRIMONIALE toutes les informations nécessaires à la bonne exécution des services et à régler les factures dans les délais convenus.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Article 5 - Droit applicable et litiges</h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes CGV sont soumises au droit français.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, les tribunaux de Paris seront seuls compétents.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGV;
